import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text-34px font-semibold" }, "Detail Cashback", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-20px" }, " Semakin besar top up saldo, semakin besar cashback yang Anda dapatkan! ", -1)
const _hoisted_3 = { class: "text-12px text-gray-lp-600" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-3 gap-2 p-4 rounded" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-span-1 font-semibold text-12px xxl:text-14px bg-red-lp-100 text-white p-4 text-center rounded" }, " Minimum Top Up "),
  /*#__PURE__*/_createVNode("div", { class: "col-span-1 font-semibold text-12px xxl:text-14px bg-red-lp-100 text-white p-4 text-center rounded" }, " Maksimal Top Up "),
  /*#__PURE__*/_createVNode("div", { class: "col-span-1 font-semibold text-12px xxl:text-14px bg-red-lp-100 text-white p-4 text-center rounded" }, " Cashback ")
], -1)
const _hoisted_5 = { class: "col-span-1 flex flex-row ml-4" }
const _hoisted_6 = { class: "w-full bg-white py-2 px-6 rounded text-center font-semibold" }
const _hoisted_7 = { class: "col-span-1 flex flex-row mx-2" }
const _hoisted_8 = { class: "w-full bg-white py-2 px-6 rounded text-center font-semibold" }
const _hoisted_9 = { class: "col-span-1 flex flex-row mr-4" }
const _hoisted_10 = { class: "w-full bg-white py-2 px-6 rounded text-center font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.showModalDetailCashback,
    persistent: false,
    header: false,
    customHeight: "480px",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = 
      () => {
        _ctx.setShowModalDetailCashback(false);
      }
    ),
    showOverflow: "",
    customBody: "bg-gray-lp-1000 px-4 py-3 rounded-lg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode("div", _hoisted_3, " *Periode cashback berlaku dari tanggal " + _toDisplayString(_ctx.startDate) + " - " + _toDisplayString(_ctx.endDate), 1),
      _hoisted_4,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (tier, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "grid grid-cols-3 gap-2 pb-4 border-dashed"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.formatPriceMin(tier.min_balance)), 1)
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.formatPriceMax(index)), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(tier.percentage) + "% ", 1)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}